import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useReasonSet = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, uuid} = useContext(OrderContext);


  const postReason = async (id, product_id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/set_reason/`, {
        reason_id : id,
        order_product_id : product_id
      });
      const data = response.data;
     
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return {postReason};
};

export default useReasonSet;
